define([], function() {
    'use strict';
    /**
     * Determines if a given object is a DOM element.
     * @function module:morningstar.asterix.util/isDomElement
     * @param  {any}  any type
     * @return {Boolean} true if DOM element, false if not
     */
    var isDomElement = function(elm) {

        return elm instanceof HTMLElement;
    };

    return isDomElement;
});



/*****************
 ** WEBPACK FOOTER
 ** ./components/core/src/js/util/is-dom-element.js
 ** module id = 18
 ** module chunks = 0
 **/